'use strict';

import Choices from 'choices.js';

const form = {
    el: {
		form:			document.querySelector('.form:not(.news_nl_form)'),
		invalids:		document.querySelectorAll('.form:not(.news_nl_form) .field'),
        radio:      	document.querySelectorAll('.form:not(.news_nl_form) .field_radio'),
		text:			document.querySelectorAll('.form:not(.news_nl_form) .field_text'),
		email:      	document.querySelectorAll('.form:not(.news_nl_form) .field_email'),
		select:     	document.querySelectorAll('.form:not(.news_nl_form) .field_select'),
		textarea:		document.querySelectorAll('.form:not(.news_nl_form) .field_textarea'),
		file:			document.querySelectorAll('.form:not(.news_nl_form) .field_file'),
		customSelect:   document.querySelector('.form:not(.news_nl_form) .select_custom'),
		checkbox:      	document.querySelectorAll('.form:not(.news_nl_form) .field_checkbox'),
        mandatory:  	document.querySelectorAll('.form:not(.news_nl_form) .field_mandatory'),
        submit:     	document.querySelector('#input_submit:not(.nl_submit)')
    },

	init: function(){
		if(form.el.customSelect)
			form.selectInit();
		
		form.events();
    },
    events: function() {
        if(form.el.submit) {
            form.el.submit.addEventListener('click', function(e) {
                e.preventDefault();
				form.check();
				form.readyToSubmit();
            });
		}
		
		// Au clic sur les input file
		if(form.el.file) {
			form.el.file.forEach((elt) => {
				elt.addEventListener('click', function() {
					this.querySelector('input[type="file"]').click();
				})
			})
			form.el.file.forEach((elt) => {
				elt.querySelector('input[type="file"]').addEventListener('change', function() {
					var value = this.value;
					var pos = value.lastIndexOf('\\')+1;
					this.parentNode.querySelector('input[type="text"]').value = value.substr(pos, value.length)
				});
			});
		}
		
    },
    check: function() {
		// mandatory
		if(form.el.mandatory) {
            form.el.mandatory.forEach(e => {
                form.checkMandatory(e);
            });
		}
	},
	
	checkMandatory: function(e) {
		let radio = e.querySelector('input[type=radio]');
		let text = e.querySelector('input[type=text]');
		let email = e.querySelector('input[type=email]');
		let checkbox = e.querySelector('input[type=checkbox]');
		let textarea = e.querySelector('textarea');
		let select = e.querySelector('select');

		if (radio) {
			let radio = e.querySelectorAll('input[type=radio]:checked');
			radio.length > 0 ? e.classList.remove('field_invalid') : e.classList.add('field_invalid');
		}
		if (text) {
			text.value != '' ? e.classList.remove('field_invalid') : e.classList.add('field_invalid');
		}
		if (email) {
			email.value != '' && isValidEmailAddress(e.querySelector('input').value) ? e.classList.remove('field_invalid') : e.classList.add('field_invalid');
		}
		if (checkbox) {
			checkbox.checked === true ? e.classList.remove('field_invalid') : e.classList.add('field_invalid');
		}
		if (textarea) {
			textarea.value != '' ? e.classList.remove('field_invalid') : e.classList.add('field_invalid');
		}
		if (select) {
			select.value != '' ? e.classList.remove('field_invalid') : e.classList.add('field_invalid');
		}
	},

	readyToSubmit: function() {
		// document.querySelectorAll('.form .field_invalid').length > 0 ? form.errors() : form.submit();
		form.submit();
	},
	
	submit: function() {
		form.el.form.querySelector('.form_errorMsg-wrap').innerHTML = "";
		
		let request = new XMLHttpRequest();
		let protocol = window.location.protocol;
		let port = window.location.port;
		port.length > 0 ? port = ':' + port : port = '';
		let hostname = window.location.hostname;
		let path = form.el.form.getAttribute('action');
		let fullUrl = protocol + '//' + hostname + port + path;
		let formId = form.el.form.id;
		let typeForm = formId;
		
		if(form.el.form.dataset.form)
			typeForm = form.el.form.dataset.form;

		let formData = new FormData();

		let gender    = "";
		if (document.querySelector('.form input[name=gender]').checked)
			gender = document.querySelector('.form input[name=gender]:checked').value;
		let name      = document.querySelector('.form input[name=name]').value;
		let firstname = document.querySelector('.form input[name=firstname]').value;
		let email     =	document.querySelector('.form input[name=email]').value;
		let phone 	  =	document.querySelector('.form input[name=phone]').value;
		let subject   = document.querySelector('.form select[name=subject]').value;
		let message   = document.querySelector('.form textarea[name=message]').value;
		let file      = document.querySelector('.form input[name=file]');
		let consent   = document.querySelector('.form input[name=terms]').value;
		let formType  = document.querySelector('.form input[name=form_type]').value;
		let captcha   = grecaptcha.getResponse();
		
		formData.append('civility', gender);
		formData.append('name', name);
		formData.append('firstname', firstname);
		formData.append('email', email);
		if(phone)
			formData.append('phone', phone);
		formData.append('subject', subject);
		formData.append('message', message);
		if(file)
			formData.append('file', file.files[0]);
		formData.append('consent', consent);
		formData.append('formType', formType);
		formData.append('g-recaptcha-response', captcha);
		// do the request using form info
		request.open("POST", fullUrl, true);
		// want to distinguish from non-JS submits?
		request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

		request.onreadystatechange = function () {
			if (request.readyState == 4 && request.status == 200) {
				let obj = JSON.parse(request.responseText);
				if (obj.data.errors) {
					// nok
					form.scrollToMsg();
					form.el.form.classList.add('errors');

					// transform object in array to loop into it
					const errors = Object.values(obj.data.errors);
					for (const error of errors) {
						let newError = document.createElement("div");
						let errorText = document.createTextNode(error);
						newError.appendChild(errorText);
						form.el.form.querySelector('.form_errorMsg-wrap').appendChild(newError);
					}
					grecaptcha.reset();
				} else {
					// ok
					form.el.form.classList.add('wellDone');
					form.scrollToMsg();
					ga('send', 'event', 'Formulaires', 'sent', typeForm);
				}
			}
		};

		request.send(formData);
	},

	scrollToMsg: function() {
		// console.log('il y a des erreurs');
		let id = document.querySelector('.form').getAttribute('id');
		location.href = "#";
		location.href = '#' + id;
	},

	selectInit: function(e) {
        // transformation des select en div
        const choices = new Choices(form.el.customSelect, {
			searchEnabled: false,
			shouldSort: false
		});
	},
}

function isValidEmailAddress(emailAddress) {
	let pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
	return pattern.test(emailAddress);
};

export default form;


// WEBPACK FOOTER //
// ./src/scripts/components/form.js